import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import ReactDOMServer from "react-dom/server";
import { axiosPath } from "../../../../routing/helpers/router";
import BreadcrumbHandler from "../../../../layout/components/breadcrumb/BreadcrumbHandler";
import CommunicationPipelineAdminNavbar from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminNavbar";
import CommunicationPipelineAdminReportSentDefaultTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportSentTemplates/CommunicationPipelineAdminReportSentDefaultTemplate";
import CommunicationPipelineAdminReportSentHaizeaTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportSentTemplates/CommunicationPipelineAdminReportSentHaizeaTemplate";
import Translator from "../../../../layout/components/helpers/Translator";
import useIsMounted from "../../../../layout/components/hooks/useIsMounted";
import errorHandler from "@/layout/components/error/ErrorHandler";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";
import { AppNoInfo } from "@/layout/AppComponents";
import * as currentPageAction from "@/store/actions/currentPageAction";

export default function CommunicationPipelineAdminReportSentScreen() {
  const { moduleBridgeHex, reportHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const reportTemplate = useSelector(
    (state) => state.currentPage?.moduleData?.reportTemplate,
  );
  const moduleData = useSelector((state) => state.currentPage?.moduleData);
  const [report, setReport] = useState();

  const loadReport = useCallback(async () => {
    axios
      .post(axiosPath("api_r_user_module_communicationPipeline_report_get"), {
        moduleBridgeHex,
        reportHex,
      })
      .then((r) => {
        if (isMounted.current) {
          setReport(r?.data);
        }
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [moduleBridgeHex, reportHex]);

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  useEffect(() => {
    loadReport();
  }, []);

  const renderTemplate = useCallback(() => {
    switch (reportTemplate) {
      case "haizea":
        return (
          <CommunicationPipelineAdminReportSentHaizeaTemplate report={report} />
        );
      default:
        return (
          <CommunicationPipelineAdminReportSentDefaultTemplate
            report={report}
          />
        );
    }
  }, [reportTemplate, report]);

  if (!moduleData) return <AppNoInfo />;

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <Container>
        <BreadcrumbHandler
          paths={
            moduleBridgeHex
              ? [
                  {
                    name: `${moduleData?.moduleName}`,
                    route: {
                      name: "user_module_communicationPipeline_home",
                      params: {
                        moduleBridgeHex,
                      },
                    },
                  },
                  {
                    name: `${ReactDOMServer.renderToString(
                      <Translator
                        file="module-communicationPipeline"
                        name="complaint"
                      />,
                    )} - ${reportHex}`,
                  },
                ]
              : [{ name: "..." }]
          }
        />
        <CommunicationPipelineAdminNavbar />
        {report && renderTemplate()}
      </Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 0.5rem !important;
  padding-bottom: 100px;
  h3 {
    font-size: 14px;
    font-weight: 700;
    margin: 32px 0 0 0;
  }
  .minHeight600 {
    min-height: 600px;
  }
  .user-info {
    border: 1px solid lightgray;
    padding: 24px;
  }
`;
